<template>
  <div class="pickup-page">
    <div class="page-header" style="background:linear-gradient(135deg,#d46b08,#fa8c16);">
      <div class="back-btn" @click="goBack">{{ $t('wholesaler.AfterSalesPickupPage.line4_text') }}</div>
      <h1>{{ $t('wholesaler.AfterSalesPickupPage.line5_text') }}</h1>
      <div class="sub">{{ detail.afterSalesNo }}</div>
    </div>

    <div v-loading="loading" class="content">
      <!-- 概要 -->
      <div class="module">
        <div class="module-header"><span class="icon">📋</span><span class="title">{{ $t('wholesaler.AfterSalesPickupPage.line12_text') }}</span></div>
        <div class="module-body">
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesPickupPage.line14_text') }}</span><span class="value mono" style="color:#457b9d;">{{ detail.orderNo }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesPickupPage.line15_text') }}</span><span class="value">{{ schemeText(detail.resolutionType) }}</span></div>
          <div class="row"><span class="label">{{ $t('wholesaler.AfterSalesPickupPage.line16_text') }}</span><span class="value">{{ returnMethodText(detail.returnMethod) }}</span></div>
          <div class="row" v-if="detail.pickupTaskId"><span class="label">{{ $t('wholesaler.AfterSalesPickupPage.line17_text') }}</span><span class="value mono">TASK-{{ detail.pickupTaskId }}</span></div>
        </div>
      </div>

      <!-- 取件商品 -->
      <div class="module">
        <div class="module-header"><span class="icon">📦</span><span class="title">{{ $t('wholesaler.AfterSalesPickupPage.line23_text') }}</span></div>
        <div class="module-body">
          <div class="item-row" v-for="item in returnItemsList" :key="item.productId || item.id">
            <span class="item-name">{{ item.productName || '商品' }}</span>
            <span class="item-qty">× {{ item.quantity }}</span>
          </div>
        </div>
      </div>

      <!-- 确认取件 -->
      <div class="module action-section">
        <div class="module-body">
          <el-button type="primary" size="large" style="width:100%;height:48px;" @click="confirmPickup" :loading="submitting">
            ✅ 确认取件完成
          </el-button>
          <el-input v-model="pickupNote" type="textarea" :rows="2" :placeholder="$t('wholesaler.AfterSalesPickupPage.line38_placeholder')" maxlength="200" style="margin-top:12px;"></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAfterSalesDetail, confirmPickup } from '@/services/afterSales';

export default {
  name: 'AfterSalesPickupPage',
  data() {
    return { loading: false, submitting: false, detail: {}, pickupNote: '' };
  },
  computed: {
    returnItemsList() {
      try {
        const items = this.detail.returnItems ? JSON.parse(this.detail.returnItems) : [];
        if (items.length > 0) return items;
        return this.detail.applyItems ? JSON.parse(this.detail.applyItems) : [];
      } catch { return []; }
    }
  },
  created() { this.loadDetail(); },
  methods: {
    async loadDetail() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        this.detail = await getAfterSalesDetail(id);
      } catch (e) { this.$message.error('加载失败: ' + (e.message || e)); }
      finally { this.loading = false; }
    },
    goBack() { this.$router.back(); },
    schemeText(type) { const m = { RETURN_REFUND:'退货退款', EXCHANGE:'换货', RESEND:'补发', PARTIAL_REFUND:'部分退款', RELIEF:'减免', NO_ACTION:'不处理' }; return m[type] || type; },
    returnMethodText(m) { const map = { COURIER_PICKUP:'配送员取件', SELF_SEND:'客户自寄' }; return map[m] || m; },
    async confirmPickup() {
      this.submitting = true;
      try {
        await confirmPickup(this.detail.id);
        this.$message.success('取件完成，商品已送回仓库');
        this.$router.push(`/wholesaler/after-sales/${this.detail.id}`);
      } catch (e) { this.$message.error('操作失败: ' + (e.message || e)); }
      finally { this.submitting = false; }
    }
  }
};
</script>

<style scoped>
.page-header { color: #fff; padding: calc(16px + env(safe-area-inset-top, 0px)); }
.back-btn { font-size: 12px; opacity: 0.8; cursor: pointer; margin-bottom: 4px; }
.back-btn:hover { opacity: 1; }
.page-header h1 { font-size: 17px; }
.page-header .sub { font-size: 12px; opacity: 0.8; }

.content { max-width: 600px; margin: 0 auto; padding-bottom: 60px; background: #f5f5f5; min-height: calc(100vh - 80px); }
.module { margin: 8px; background: #fff; border-radius: 8px; overflow: hidden; }
.module-header { display: flex; align-items: center; padding: 12px 12px 8px; gap: 6px; border-bottom: 1px solid #f0f0f0; }
.module-header .icon { font-size: 16px; }
.module-header .title { font-size: 14px; font-weight: 600; flex: 1; }
.module-body { padding: 12px; }

.row { display: flex; justify-content: space-between; padding: 8px 0; font-size: 13px; }
.row .label { color: #999; }
.row .value { font-weight: 500; text-align: right; }
.row .value.mono { font-family: monospace; font-size: 12px; }
.row + .row { border-top: 1px dashed #f0f0f0; }

.item-row { display: flex; align-items: center; gap: 8px; padding: 8px 0; border-bottom: 1px dashed #f0f0f0; }
.item-row:last-child { border-bottom: none; }
.item-name { flex: 1; font-size: 13px; font-weight: 500; }
.item-qty { font-size: 12px; color: #999; }

.action-section { border: 2px solid #fa8c16; }
</style>
